import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Card, CardHeader, Table, Row, Button, Spinner } from "reactstrap";

const AdditionalChargesTable = ({
  data,
  addToggle,
  editToggle,
  deleteToggle,
  setEditData,
  setIndex,
}) => {
  const history = useHistory();
  const { chargesLoading } = useSelector((state) => state.setting);

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <Row>
      <div className="col">
        <Card className="shadow">
          <CardHeader className="d-lg-flex d-sm-block justify-content-between">
            <div className="d-flex align-items-center">
              <Button
                size="sm"
                color="primary"
                onClick={() => {
                  history.push("/admin/settings/client-setting-menu");
                }}
              >
                <i className="fas fa-arrow-left"></i>
              </Button>
              <h3 className="pt-2 ml-2">Additional Charges</h3>
            </div>

            <Button color="primary" onClick={addToggle}>
              Add
            </Button>
          </CardHeader>

          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Type</th>
                <th scope="col">Fee</th> <th scope="col">isActive</th>
                <th scope="col">Actions</th>
              </tr>
            </thead>

            {chargesLoading ? (
              <tr>
                <td colSpan="12" className="py-5">
                  <div className="d-flex justify-content-center align-items-center">
                    <Spinner size="md" color="primary" />
                  </div>
                </td>
              </tr>
            ) : (
              <tbody>
                {data?.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td>{capitalizeFirstLetter(item.name)}</td>
                      <td>{capitalizeFirstLetter(item.type)}</td>
                      <td>{item.fee}</td>
                      <td>{item.isActive ? "Yes" : "No"}</td>
                      <td>
                        <Button
                          className="btn-sm"
                          color="primary"
                          onClick={() => {
                            setEditData(item);
                            editToggle();
                            setIndex(index);
                          }}
                        >
                          Edit
                        </Button>
                        <Button
                          className="btn-sm ml-2"
                          color="danger"
                          onClick={() => {
                            deleteToggle(item, index);
                          }}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      No Additional Charges Added
                    </td>
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </Card>
      </div>
    </Row>
  );
};

export default AdditionalChargesTable;
